require('./stylesheet/main.style.scss');

require('./stylesheet/security.scss');
 require('./stylesheet/_services.scss');
require('./stylesheet/tabpanel.scss');
require('./stylesheet/_payslider.scss');

angular.module('pages.main', ['ngTouch'])
    .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider
        .state('pages.main', {
            url: 'main',
            template: require('./templates/index.html'),
            controller: require('./controllers/main'),
            data: {
                iframe: false
            },
            pageTrack: '/main',
            resolve: {
                test: function($translate) {
                    // return $translate('MAIN.REGISTRATION');
                }
            }
        });
}

module.exports = 'pages.main';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/index.js
 ** module id = 271
 ** module chunks = 1
 **/